import { Navigate, Route } from "react-router-dom";
import { PageLogin } from "src/Pages/TelasLogin/Login/Index";
import { PageLoginRegister } from "src/Pages/TelasLogin/Register/Index";
import { PageSendLinkRecoverPassword } from "src/Pages/TelasLogin/SendLinkRecoverPassword/Index";

import { UrlConfigPublic } from "./Config/UrlConfigPublic";

export const PublicRoutes = () => {
  return (
    <>
      <Route element={<PageLogin />} path={UrlConfigPublic.login} />

      <Route element={<PageLoginRegister />} path={UrlConfigPublic.register} />

      <Route
        element={<PageSendLinkRecoverPassword />}
        path={UrlConfigPublic.RecoverPassword}
      />

      {/* fallback */}
      <Route path="*" element={<Navigate to={UrlConfigPublic.login} />} />
    </>
  );
};
